<header *ngIf="defaultView">Edit Graphics</header>

<div class="scrollable">
  <ng-template ngFor let-item [ngForOf]="getTextFields()">
    <icn-collapsible [label]="item.label">
      <icn-graphics-text
        [textField]="item"
        [isDynamicPromoGraphicInstance]="isDynamicPromoGraphicInstance"
      ></icn-graphics-text>
    </icn-collapsible>
  </ng-template>
  <icn-collapsible label="COLOR THEME" *ngIf="getColorFields().length > 0">
    <icn-graphics-colors [colorFields]="getColorFields()"></icn-graphics-colors>
  </icn-collapsible>

  <icn-collapsible label="SCALE AND POSITION">
    <icn-graphics-scale-position
      [scaleField]="getScaleField()"
      [positionField]="getPositionField()"
      [(zLayer)]="graphicsInfo.zLayer"
      (zLayerChange)="zIndexChangedEventHandler($event)"
      [(overrideGraphicPosition)]="graphicsInfo.overrideGraphicPosition"
    >
    </icn-graphics-scale-position>
  </icn-collapsible>

  <icn-collapsible label="DURATION" *ngIf="showDurationField()">
    <icn-graphics-duration
      [durationValues]="getDurationValues()"
      (updateDurationMS)="onDurationChanged($event)"
    >
    </icn-graphics-duration>
  </icn-collapsible>

  <icn-collapsible label="MEDIA" *ngIf="getMediaFields().length > 0">
    <icn-graphics-media [mediaFields]="getMediaFields()"></icn-graphics-media>
  </icn-collapsible>
</div>
